import _concat from "lodash/concat";
import dashboard from "./dashboard";

export default {
  path: "/dashboard",
  component: () => import("@/layouts/FullLayout"),
  children: _concat(dashboard)
};
